import { ReactKeycloakProvider } from "@react-keycloak/web";

import keycloak, {
  keycloakProviderInitConfig,
  isLoadingCheck,
  storeToken,
  updateToken,
} from "../../utils/keycloak";
import TitleComponent from "../TitleComponent";
import Layout from "../layout/Layout";
import Loading from "../../pages/Loading";
import "antd/dist/antd.css";

function App(): JSX.Element {
  return (
    <>
      <TitleComponent
        title="Portal DN Power BI"
        description="Portal de reportes de Power BI"
        keywords="Reportes Dichter&Neira"
      />
      <ReactKeycloakProvider
        authClient={keycloak}
        initOptions={keycloakProviderInitConfig}
        onTokens={({ token }) => {
          storeToken(token ? token : "");
        }}
        LoadingComponent={<Loading />}
        onEvent={(event, error) => {
          if (event === "onTokenExpired") {
            updateToken();
          }
        }}
        isLoadingCheck={isLoadingCheck}
      >
        <Layout />
      </ReactKeycloakProvider>
    </>
  );
}

export default App;
